import { styled, css } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

function breakpointCss(breakpoint: string | null) {
  const breakpointSuffix = breakpoint ? `-${breakpoint}` : '';

  const fn = (cssProperty: string, variable: string) => {
    const varName = `--b-${variable + breakpointSuffix}`;

    return css`
      &[style*='${varName}:'] {
        ${cssProperty}: var(${varName})
      }
    `;
  };

  return css`
    ${fn('position', 'position')};
    ${fn('top', 'top')};
    ${fn('right', 'right')};
    ${fn('bottom', 'bottom')};
    ${fn('left', 'left')};
    ${fn('z-index', 'zIndex')};
    ${fn('transform', 'transform')};

    ${fn('margin', 'm')};
    ${fn('margin-inline', 'mx')};
    ${fn('margin-block', 'my')};
    ${fn('margin-top', 'mt')};
    ${fn('margin-right', 'mr')};
    ${fn('margin-bottom', 'mb')};
    ${fn('margin-left', 'ml')};

    ${fn('padding', 'p')};
    ${fn('padding-inline', 'px')};
    ${fn('padding-block', 'py')};
    ${fn('padding-top', 'pt')};
    ${fn('padding-right', 'pr')};
    ${fn('padding-bottom', 'pb')};
    ${fn('padding-left', 'pl')};

    ${fn('display', 'display')};

    ${fn('width', 'width')};
    ${fn('height', 'height')};
    ${fn('max-width', 'maxWidth')};
    ${fn('max-height', 'maxHeight')};
    ${fn('min-width', 'minWidth')};
    ${fn('min-height', 'minHeight')};

    ${fn('flex', 'flex')};
    ${fn('order', 'order')};
    ${fn('align-self', 'alignSelf')};
    ${fn('justify-self', 'justifySelf')};
    ${fn('align-items', 'alignItems')};
    ${fn('align-content', 'alignContent')};
    ${fn('justify-content', 'justifyContent')};
    ${fn('flex-basis', 'flexBasis')};
    ${fn('flex-direction', 'flexDirection')};
    ${fn('flex-grow', 'flexGrow')};
    ${fn('flex-shrink', 'flexShrink')};
    ${fn('flex-wrap', 'flexWrap')};

    ${fn('overflow', 'overflow')};

    ${fn('color', 'color')};
    ${fn('opacity', 'opacity')};
    ${fn('visibility', 'visibility')};

    ${fn('background', 'bg')};
    ${fn('background-image', 'backgroundImage')};
    ${fn('background-size', 'backgroundSize')};
    ${fn('background-position', 'backgroundPosition')};
    ${fn('background-repeat', 'backgroundRepeat')};
    ${fn('background-color', 'backgroundColor')};

    ${fn('border', 'border')};
    ${fn('border-top', 'borderTop')};
    ${fn('border-left', 'borderLeft')};
    ${fn('border-right', 'borderRight')};
    ${fn('border-bottom', 'borderBottom')};
    ${fn('border-radius', 'borderRadius')};
    ${fn('box-shadow', 'boxShadow')};

    ${fn('font-size', 'fontSize')};
    ${fn('font-family', 'fontFamily')};
    ${fn('line-height', 'lineHeight')};
    ${fn('font-weight', 'fontWeight')};
    ${fn('letter-spacing', 'letterSpacing')};

    ${fn('text-align', 'textAlign')};
    ${fn('vertical-align', 'verticalAlign')};
    ${fn('text-overflow', 'textOverflow')};
    ${fn('text-transform', 'textTransform')};
    ${fn('text-decoration', 'textDecoration')};
    ${fn('white-space', 'whiteSpace')};
    ${fn('word-break', 'wordBreak')};

    ${fn('transition', 'transition')};
    ${fn('will-change', 'willChange')};
    ${fn('pointer-events', 'pointerEvents')};

    ${fn('gap', 'gap')};
    ${fn('grid-auto-flow', 'gridAutoFlow')};
    ${fn('grid-area', 'gridArea')};
    ${fn('grid-template-areas', 'gridTemplateAreas')};
    ${fn('grid-column', 'gridColumn')};
    ${fn('column-gap', 'gridColumnGap')};
    ${fn('grid-auto-columns', 'gridAutoColumns')};
    ${fn('grid-template-columns', 'gridTemplateColumns')};
    ${fn('grid-row', 'gridRow')};
    ${fn('row-gap', 'gridRowGap')};
    ${fn('grid-auto-rows', 'gridAutoRows')};
    ${fn('grid-template-rows', 'gridTemplateRows')};
  `;
}

export const StyledBox = styled.div`
  ${breakpointCss(null)};

  @media (min-width: ${cssBreakpoints.xsUp}) {
    ${breakpointCss('sm')};
  }

  @media (min-width: ${cssBreakpoints.smUp}) {
    ${breakpointCss('md')};
  }

  @media (min-width: ${cssBreakpoints.mdUp}) {
    ${breakpointCss('lg')};
  }

  @media (min-width: ${cssBreakpoints.lgUp}) {
    ${breakpointCss('xl')};
  }
`;
